import { z } from "zod";
import { identityBlock, futureDateIso } from "./common.js";
export const individualMedicalPayloadSchema = identityBlock.extend({
    ageOfPrincipal: z.number().int().min(18).max(85),
    includeSpouse: z.boolean().default(false),
    numberOfChildren: z.number().int().min(0).max(10),
    inpatientLimitKes: z.number().int().min(0),
    outpatientLimitKes: z.number().int().min(0),
    maternityLimitKes: z.number().int().min(0),
    dentalLimitKes: z.number().int().min(0),
    opticalLimitKes: z.number().int().min(0),
    coverStartDate: futureDateIso,
});
